module.exports = __webpack_public_path__ + "static/media/ContactCat.5b3ad48f.mp4";